import { render } from "./CareersView.vue?vue&type=template&id=b2d7cce4"
import script from "./CareersView.vue?vue&type=script&lang=js"
export * from "./CareersView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__